export default "__VITE_ASSET__DBPSj_y5__"